import React, { useState, useEffect, useContext } from 'react';
import { GlobleContext, getContactUsData } from './utils'
import { useCookies } from 'react-cookie';
import '../App.css'
import axios from 'axios';
import { NavLink } from 'react-bootstrap';

const Footer = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL || '/';
  const corporateURL = process.env.REACT_APP_Corporate;
  const [vskCookies, setvskCookies, removeCookie] = useCookies(['vsk_Cookie']);
  const { getContactUsData, contactuseData, getProfileData, profileData, getProductCategoryData, productCategoryData } = useContext(GlobleContext)
  const [brochureData, setBrochureData] = useState([])
  const maxIndex = 6;

  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  useEffect(() => {
    getContactUsData();
    getProfileData();
    getProductCategoryData();
    getCorporateBrochure();
  }, []);

  const getCorporateBrochure = async () => {
    const response = await axios.post(`${baseUrl}Corporate/GetCorporate`, { PaginationID: "-1", CorporateType: "Brochure" });
    if (response.status === 200) {
      if (response.data.data.length > 0) {
        setBrochureData(response.data.data[0]);
      }
    }
  };

  const handleMenuClick = (ProductCategoryID) => {
    // Save data in the cookie
    removeCookie('PCID')
    setvskCookies('PCID', ProductCategoryID);
  };

  const handleDownload = () => {
    // debugger;
    // // Get the file URL
    // const fileUrl = corporateURL + brochureData.PDF

    // // Create a hidden link
    // const a = document.createElement('a');
    // a.href = fileUrl;
    // // a.target = '_blank';
    // a.download = 'vishwakarma-engineering-works.pdf';

    // // Append the link to the document and trigger the click event
    // document.body.appendChild(a);
    // a.click();

    // // Remove the link from the document
    // document.body.removeChild(a);

    // using Java Script method to get PDF file
    const fileUrl = corporateURL + brochureData.PDF

    fetch(fileUrl).then((response) => {
      response.blob().then((blob) => {

        // Creating new object of PDF file
        const fileURL =
          window.URL.createObjectURL(blob);

        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "vishwakarma-engineering-works.pdf";
        alink.click();
      });
    });
  };

  return (
    <>
      <button className='downloadbtn fp-btn' onClick={() => { handleDownload() }}><i className="fa fa-download font20"></i></button>

      <div id="footer-widgets" className="footer-widgets widgets-area">
        <div className="contact-widget">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12 col-sm-12">
                <div className="footer-contact clearfix">
                  <div id="text-7" className="widget widget_text">
                    <div className="textwidget">
                      <a href="/Splash">
                        {/* <img src="/images/logo-light.png" alt="logo-light" className="logo-footer" /> */}
                        {/* <img src="/images/Vishwakarma_logo.png" alt="logo-light" className="logo-footer" style={{ height: '70px', width: '100%' }} /> */}

                        <div style={{ background: '#fff' }}>
                          <img src="/images/VEW_logo.png" alt="FactoryPlus" className="wblogo" />
                          <span className='footerheading1'>Vishwakarma</span><br></br>
                          <span className='footerheading2'>Engineering Works</span>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div id="text-5" className="widget widget_text">
                    {contactuseData.ContactPerson1 &&
                      <div className="textwidget"><i className="factory-people"></i>
                        <h4>Contact Detail</h4>
                        <p>{contactuseData.ContactPerson1}</p>
                      </div>
                    }
                    <br></br>
                    <div className="textwidget"><i className="factory-technology"></i>
                      <h4>GST Number</h4>
                      <p className="gstnumber"><a style={{ color: '#c8c8c8', fontSize: '18px' }} href={contactuseData.GSTNo}> {contactuseData.GSTNo}</a></p>
                    </div><br></br>

                    {(contactuseData?.MobileNo1 || contactuseData?.MobileNo2) &&
                      <div className="textwidget"><i className="factory-technology"></i>
                        <h4>Call Us</h4>
                        {contactuseData?.MobileNo1 && <p className="number"><a style={{ color: '#c8c8c8' }} href={"tel:" + contactuseData.MobileNo1}>+91 {contactuseData.MobileNo1}</a></p>}
                        {contactuseData?.MobileNo2 && <p className="number"><a style={{ color: '#c8c8c8' }} href={"tel:" + contactuseData.MobileNo2}>+91 {contactuseData.MobileNo2}</a></p>}
                      </div>
                    }

                  </div>
                  {contactuseData.Address &&
                    <div id="text-6" className="widget widget_text footeraddress">
                      <div className="textwidget"><i className="factory-travel"></i>
                        <h4>Address</h4>
                        <p>{contactuseData.Address}</p>
                        {contactuseData.DirectionLink &&
                          <a target='_blank' href={contactuseData.DirectionLink} style={{ color: '#fff', textDecoration: 'underline' }}><p>Get Directions</p></a>
                        }
                      </div>
                    </div>
                  }

                  <div className="topbar-right topbar-widgets text">
                    <div id="text-11" className="widget widget_text" style={{ marginTop: '4%', marginLeft: '1%' }}>
                      <div className="textwidget">
                        <p className=""><span className="text" style={{ color: '#fff' }}>Get In Touch</span>
                          <ul className="topbar-socials">

                            {contactuseData.FacebookLink &&    
                               <li>
                                 <a target='_blank' href={contactuseData.FacebookLink}>
                                   <i className="fa fa-facebook" aria-hidden="true" style={{ marginRight: '10px' }}></i>
                                 </a>
                               </li>
                            }
                            {contactuseData.TwitterLink &&
                              <li><a target='_blank' href={contactuseData.TwitterLink}><i className="fa fa-twitter" aria-hidden="true" style={{ marginRight: '10px' }}> </i></a></li>
                            }
                            {contactuseData.LinkedinLink &&
                              <li><a target='_blank' href={contactuseData.LinkedinLink}><i className="fa fa-linkedin" aria-hidden="true" style={{ marginRight: '10px' }}> </i></a></li>
                            }
                            {contactuseData.YoutubeLink &&
                              <li><a target='_blank' href={contactuseData.YoutubeLink}><i className="fa fa-youtube-play" aria-hidden="true"> </i></a></li>
                            }
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-sidebars">
          <div className="container">
            <div className="row">

              <div className="footer-sidebar footer-1 col-xs-12 col-sm-6 col-md-3">
                <div id="text-2" className="widget widget_nav_menu">
                  <h4 className="widget-title">Company Profile</h4>
                  <div className="menu-service-menu-container">
                    <ul id="menu-service-menu" className="menu">
                      <li><a href="/Splash">Home</a></li>
                      <li><a href="/Profile">Profile</a></li>
                      <li><a href="/CorporateBrochure">Corporate Brochure</a></li>
                      <li><a href="/CorporatePresentation">Corporate Presentation</a></li>
                      <li><a href="/DistributerEnquiry">Distributor Enquiry</a></li>
                      <li><a href="/ContactUs">Contact Us</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="footer-sidebar footer-2 col-xs-12 col-sm-6 col-md-3">
                <div id="nav_menu-2" className="widget widget_nav_menu">
                  <h4 className="widget-title">Our Services</h4>
                  <div className="menu-service-menu-container">
                    <ul id="menu-service-menu" className="menu">

                      {productCategoryData &&
                        productCategoryData.map((item, index) => (
                          index <= maxIndex ? (
                            <li key={index} value={item.ProductCategoryID} onClick={() => handleMenuClick(item.ProductCategoryID)}>
                              <a href={`/Product/${item.ProductCategory.replace(/\s+/g, '_')}`}>
                                {item.ProductCategory}
                              </a>
                            </li>
                          ) : null
                        ))
                      }

                    </ul>
                  </div>
                </div>
              </div>
              {profileData.CompanyVideo &&
                <div className="footer-sidebar footer-3 col-xs-12 col-sm-6 col-md-6">
                  <div id="latest-project-widget-2" className="widget latest-project-widget">
                    <h4 className="widget-title">Corporate Video</h4>
                    <iframe src={profileData.CompanyVideo}
                      frameBorder='0'
                      allow='autoplay; encrypted-media'
                      allowFullScreen
                      title='video'
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <footer id="colophon" className="site-footer" style={{ padding: '10px 0 10px 0' }}>
        <div className="container">
          <div className="row">
            <div className="footer-copyright col-md-12 col-sm-12 col-sx-12">
              <div className="site-info text-center">
                <a target='_blank' href="https://smtechno.com"> {new Date().getFullYear()} © S M Techno Consultants PVT LTD. All Rights Reserved.</a> </div>
            </div>
            {/* <div className="footer-text col-md-6 col-sm-12 col-xs-12 text-right">
              <a href="#">Purchase FactoryPlus</a>
            </div> */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;

